<spike-base-page [breadcrumbItems]="breadcrumb" [title]="'Flussi di cassa: ' + year()">
  <div actions>
        
    <p-button (click)="pagePrev()" class="mr-2" [label]="(year()-1)+''" icon="pi pi-arrow-left"></p-button>
    <p-button (click)="pageNext()" class="mr-2" [label]="(year()+1)+''" icon="pi pi-arrow-right"></p-button>
  </div>

  <div class="spike-table-card">
    
    <spike-trade-monthly-recap-table [headerName]= "''" [recapList] = [] [showHeader]= "true" [transformType] ="'currency'"> </spike-trade-monthly-recap-table>

    <spike-trade-monthly-recap-table 
      [headerName]="'Entrate'" 
      [recapList]="tradeEtiquetteRecapIncomeList()" 
      [addRowTotal]="true" 
      [transformType]="'currency'"
      [enableDetail]="true"
      (onDetail)="openDetail($event)"> 
    </spike-trade-monthly-recap-table>
    <spike-trade-monthly-recap-table  
      [headerName]="'Uscite'"
      [recapList]="tradeEtiquetteRecapOutcomeList()"
      [addRowTotal]="true"
      [transformType]="'currency'"
      [enableDetail]="true"
      (onDetail)="openDetail($event)">  
    </spike-trade-monthly-recap-table>
    <spike-trade-monthly-recap-table 
      [headerName]="'Totale Netto'" 
      [recapList]="tradeEtiquetteRecapTotalList()" 
      [transformType]="'currency'"> 
    </spike-trade-monthly-recap-table>

    <div style="margin-top: 15px;">
      <spike-trade-monthly-recap-table 
        [headerName]="'Tasso di Risparmio'" 
        [recapList]="tradeEtiquetteRecapSavingRateList()" 
        [transformType]="'percentage'"> 
      </spike-trade-monthly-recap-table>
    </div>

  </div>
</spike-base-page>

@if(isDetailVisible()){
<p-drawer 
    header="Dettaglio" 
    (onHide)="isDetailVisible.set(false)" 
    [visible]="isDetailVisible()"
    position="right" 
    styleClass="!w-full md:!w-80 lg:!w-[80rem]">

    <spike-trades-table [items]="trades()" />
</p-drawer>
}